import { useEffect, useState } from "react";
import { IInsightsCategory, fetchBlogById } from "./InsightsController";
import ICImage from "../../core-component/ICImage";
import { getRelativeTime } from "../../utils/AppFunctions";
import { useLocation, useParams } from "react-router-dom";
import CustomEditor from "../../screens/product-services/Web/CustomEditor";
import PublicCarousel from "../insights-in-use/PublicCarousel";
import ExploreView from "./ExploreView";
import { MEDIA_TYPE, PUBLIC_HEADER_TABS, PUBLIC_TABS } from "../../utils/AppEnumerations";
import PdfViewer from "../../components/common/PdfViewer";
import UseTranslationHook from "../../hooks/UseTranslationHook";
import {
  IInsightsDetail,
  fetchInsightsCategoryApiCall,
} from "../insights-in-use/InsightsController";
import usePaginationHook from "../../hooks/UsePaginationHook";
import { PAGINATION_PER_PAGE_ROWS } from "../../utils/AppConstants";
import BackButton from "../../components/common/BackButton";
import PublicHeader from "../public-header/PublicHeader";
const InsightsDetailsView = () => {
  const [blogsFormInitialValues, setBlogsFormInitialValues] =
    useState<IInsightsDetail>();
  const [cid, setCid] = useState<number | null>(null);
  const [insightsCategoryList, setInsightsCategoryList] = useState<
    IInsightsCategory[]
  >([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const [openPdfModal, setOpenPdfModal] = useState<boolean>(false);
  const [pdfFile, setPdfFile] = useState<string>("");
  const { pagination, setPagination } = usePaginationHook({
    pagination: {
      per_page_rows: Number(PAGINATION_PER_PAGE_ROWS.Thousand),
      current_page: 1,
      sort_by: "",
      order_by: "DESC",
    },
  });
  const params = useParams<{ id: string; categoryName: string }>();
  const openPdfModalHandler = (pdfFilePath: string) => {
    setPdfFile(pdfFilePath);
    setOpenPdfModal(true);
  };
  const { t } = UseTranslationHook();
  const closePdfModalHandler = () => {
    setOpenPdfModal(false);
  };
  useEffect(() => {
    fetchInsightsCategoryApiCall(
      setLoading,
      setInsightsCategoryList,
      setPagination,
      pagination,
      setCid
    );
  }, []);
  useEffect(() => {
    document.title = `${blogsFormInitialValues?.blog_title} | ${PUBLIC_TABS.Insights}`;

    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  })
  const blogId = params.id ? parseInt(params.id) : undefined;
  useEffect(() => {
    if (!isNaN(blogId as number)) {
      fetchBlogById(blogId, setBlogsFormInitialValues);
    } else {
      console.error("Invalid blog ID");
    }
  }, [params]);

  return (
    <>
      <div className='h-24'>
        <PublicHeader activeTab={PUBLIC_HEADER_TABS.Insights} />
      </div>
      <div
        className={`grid grid-cols-12 bg-skin-insights-details`}
      >
        <div className="col-span-12 w-full h-screen remove-scrollbar-width overflow-y-scroll">
          <div className="col-span-12 flex justify-start items-center comman-padding w-full">
            <BackButton containerClassName="!bg-white" />
          </div>
          <div className="col-span-12 md:col-span-10 lg:col-span-12 xl:col-span-12 flex  justify-center  overflow-hidden">
            <div className="p-6 mt-4  text-skin-insight-details xl:w-1/2 w-full text-center remove-scrollbar-width overflow-auto">
              {blogsFormInitialValues?.blog_categories &&
                blogsFormInitialValues?.blog_categories.length > 0 && (
                  <div className="flex gap-4 mb-4 overflow-x-scroll">
                    {blogsFormInitialValues?.blog_categories.map(
                      (item, index) => (
                        <div
                          key={index}
                          className="text-[12px] flex-shrink-0 !rounded-[10px] border-2 !border-[#99b5a1] p-2 w-fit text-skin-title-insights"
                        >
                          {item.category_title}
                        </div>
                      )
                    )}
                  </div>
                )}
              <h1 className="lg:text-5xl text-2xl font-bold text-left mb-4">
                {blogsFormInitialValues?.blog_title}
              </h1>
              <div className="flex justify-start items-center mb-4">
                <div className=" rounded-full overflow-hidden p-2 ">
                  <ICImage
                    className="!w-10 !h-10 object-cover rounded-full"
                    imageUrl={blogsFormInitialValues?.profile_url}
                  />
                </div>
                <div className="ml-2">
                  <div className="text-sm">
                    {blogsFormInitialValues?.created_by}
                  </div>
                  <div className="text-sm text-left">
                    {blogsFormInitialValues?.created_date
                      ? getRelativeTime(
                        blogsFormInitialValues?.created_date.toString()
                      )
                      : ""}
                  </div>
                </div>
              </div>
              <div className="mb-6 public-carousel">
                {blogsFormInitialValues && (
                  <PublicCarousel items={blogsFormInitialValues.app_media} />
                )}
              </div>
              <div className="flex justify-start flex-wrap">
                {blogsFormInitialValues?.blog_tags &&
                  blogsFormInitialValues?.blog_tags.length > 0 &&
                  blogsFormInitialValues?.blog_tags?.map((tag, index) => (
                    <div
                      key={index}
                      className="bg-skin-tag-insights-details text-skin-tag-insights-details px-2 py-1 rounded-full mr-2 mb-4"
                    >
                      {tag}
                    </div>
                  ))}
              </div>
              <div className="text-left">
                <CustomEditor
                  containerClassName={"!text-skin-insight-details !lg:text-xl !text-sm"}
                  serviceDesc={blogsFormInitialValues?.blog_content}
                />

                {blogsFormInitialValues && blogsFormInitialValues?.app_media.length && blogsFormInitialValues?.app_media.map((value, index) => (
                  value.media_type === MEDIA_TYPE.pdf ? <div className="" key={index} onClick={() => { openPdfModalHandler(value.media_url) }}>
                    {openPdfModal && <PdfViewer pdfFile={pdfFile} onClose={closePdfModalHandler} />} {t("attachment")}:<p className="text-blue-500 underline cursor-pointer inline-block">{value.media_url}</p></div> : ""
                ))}
              </div>
            </div>
          </div>
          <div className="mt-7  flex justify-center items-center">
            <div className="w-full xl:w-3/4 p-4 xl:p-0">
              <ExploreView
                category_id={
                  blogsFormInitialValues?.blog_categories
                    ? blogsFormInitialValues?.blog_categories[0].id
                    : null
                }
                blog_id={blogId}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InsightsDetailsView;
